<template>
  <div>
    <page
      v-bind:contrastMode="contrastMode"
      v-if="pageTemplate === 'standard'"
      v-bind:pageData="pageData"
      v-bind:homePageId="homePageId"
    ></page>
    <about
      v-bind:contrastMode="contrastMode"
      v-if="pageTemplate === 'aboutUs'"
      v-bind:pageData="pageData"
    ></about>
    <projects-list
      v-bind:contrastMode="contrastMode"
      v-if="pageTemplate === 'projects'"
      v-bind:pageData="pageData"
    ></projects-list>
    <tabbed-page
      v-bind:contrastMode="contrastMode"
      v-if="pageTemplate === 'tabbed'"
      v-bind:pageData="pageData"
    ></tabbed-page>
    <project
      v-bind:contrastMode="contrastMode"
      v-if="pageTemplate === 'project'"
      v-bind:pageData="pageData"
    ></project>
    <contact
      v-bind:contrastMode="contrastMode"
      v-if="pageTemplate === 'contact'"
      v-bind:pageData="pageData"
    ></contact>
  </div>
</template>

<script>
import Page from "./Page.vue";
import About from "./About.vue";
import ProjectsList from "./ProjectsList.vue";
import Project from "./Project.vue";
import Contact from "./Contact.vue";
import TabbedPage from "./TabbedPage.vue";
import { i18nHelper } from "../services/i18nHelper";
import { getProjectViewName } from "../helpers/GetProjectViewName";
import { SUPPORTED_LANGUAGES } from "../i18n/i18n";

export default {
  name: "PageWrapper",
  components: {
    Page,
    About,
    ProjectsList,
    Project,
    Contact,
    TabbedPage
  },
  props: {
    contrastMode: Boolean
  },
  data: () => {
    return {
      pageData: null,
      pageTemplate: null,
      homePageId: null
    };
  },
  created() {
    const params = {};
    if (this.$route.params.lang !== SUPPORTED_LANGUAGES[0]) {
      params.lang = this.$route.params.lang;
    }
    if (this.$route.params.projectSlug) {
      // fetch project
      this.getPageData(null, this.$route.params.projectSlug, true);
    } else if (!this.$route.params.pageSlug) {
      // fetch frontpage
      this.$http.get("/custom/frontpage-id", { params }).then(response => {
        const homePageId = response ? response.data : null;
        this.homePageId = homePageId;
        if (homePageId) {
          this.getPageData(homePageId);
        } else {
          this.noPageIdOrSlug = true;
        }
      });
    } else {
      // fetch page
      this.getPageData(null, this.$route.params.pageSlug);
    }
  },
  methods: {
    getPageData(pageId, slug, isProject = false) {
      const params = {};
      if (this.$route.params.lang !== SUPPORTED_LANGUAGES[0]) {
        params.lang = this.$route.params.lang;
      }
      this.$spinner.show(this, this.contrastMode);
      let requestUrl = isProject ? "/wp/v2/project/" : "/wp/v2/pages/";
      if (pageId) {
        requestUrl += pageId;
      }
      if (slug) {
        params.slug = slug;
      }
      this.$http.get(requestUrl, { params }).then(response => {
        this.pageData = slug ? response.data[0] : response.data;
        document.title =
          this.pageData.id === this.homePageId
            ? this.$t("PAGE_TITLE")
            : this.pageData.title.rendered + " | " + this.$t("PAGE_TITLE");
        this.pageTemplate = isProject ? "project" : this.pageData.acf.template;
        // this.setTranslatedPage(this.pageData, pageId, slug, isProject);
        this.$spinner.hide();
      });
    },
    setTranslatedPage(pageData, pageId, slug, isProject = false) {
      const currentRouteName = isProject
        ? getProjectViewName(this.$i18n.locale)
        : "pageWrap";
      i18nHelper.setCurrentPage(
        currentRouteName,
        this.$i18n.locale,
        slug,
        pageId
      );
      const translatedPage = pageData.wpml_translations[0];
      const translatedPageLocale = translatedPage.locale.slice(0, 2);
      const translatedPageSlug = slug ? translatedPage.slug : null;
      const translatedPageId = pageId ? translatedPage.id : null;
      const translatedPageRouteName = isProject
        ? getProjectViewName(translatedPageLocale)
        : "pageWrap";
      i18nHelper.setTranslatedPage(
        translatedPageRouteName,
        translatedPageLocale,
        translatedPageSlug,
        translatedPageId
      );
    }
  }
};
</script>